import { useQuery, useQueryClient } from '@tanstack/react-query'
import { useEffect, useState } from 'react'

import { scenariosClient } from '@/api'
import { config } from '@/config'

export const useScenarioCalculationProgress = (scenarioId: number) => {
  const BASE_QUERY_KEY = scenariosClient.QUERY_KEY(scenarioId)
  const QUERY_KEY = [...BASE_QUERY_KEY, 'progress']

  const [hasProcessingStarted, setHasProcessingStarted] = useState(false)

  const queryClient = useQueryClient()

  const getCalculationProgressQuery = useQuery({
    queryKey: QUERY_KEY,
    queryFn: () => scenariosClient.getCalculationProgress(scenarioId),
    refetchInterval: config.requestsConfig.intervals.calculationsStatus
  })

  useEffect(() => {
    if (!getCalculationProgressQuery.data) return

    const { isCalculating, progress, preprocessingProgress } =
      getCalculationProgressQuery.data

    if (!isCalculating) {
      queryClient.invalidateQueries({ queryKey: BASE_QUERY_KEY })
    }

    if (preprocessingProgress === 0 && progress > 0 && !hasProcessingStarted) {
      setHasProcessingStarted(true)
      queryClient.invalidateQueries({ queryKey: BASE_QUERY_KEY })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [BASE_QUERY_KEY, getCalculationProgressQuery.data, queryClient])

  return { data: getCalculationProgressQuery.data }
}
